<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      showFilterInputs: false,
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      SaffSel: ["Staff ID", "ST5246", "ST1269"],
      BrianSelect: ["Staff", "Brian Villalobos"],
      InSelct: ["Status", "Active", "Inactive"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <div class="page-wrapper">
      <div class="content">
        <div
          class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
        >
          <h4>Staffs</h4>
          <div class="d-flex align-items-center flex-wrap row-gap-3">
            <span class="fs-14 me-2">Sort</span>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Newly Added
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active">Newly Added</a>
                <a href="javascript:void(0);" class="dropdown-item">Oldest</a>
              </div>
            </div>
            <div class="dropdown me-2">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                Export
              </a>
              <div class="dropdown-menu">
                <a href="javascript:void(0);" class="dropdown-item active">Export</a>
                <a href="javascript:void(0);" class="dropdown-item">Import</a>
              </div>
            </div>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              ><i class="ti ti-printer"></i
            ></a>
            <a
              href="javascript:void(0);"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              id="filter_search"
              @click="toggleFilterInputs"
              ><i class="ti ti-sort-descending"></i
            ></a>
            <router-link
              to="/provider/staff-grid"
              class="tags d-flex justify-content-center align-items-center border rounded me-2"
              ><i class="ti ti-layout-grid"></i
            ></router-link>
            <router-link
              to="/provider/staff-list"
              class="tags active d-flex justify-content-center align-items-center border rounded me-2"
              ><i class="ti ti-list"></i
            ></router-link>
            <a
              href="javascript:void(0);"
              class="btn btn-dark d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#add-staff"
              ><i class="ti ti-circle-plus me-2"></i>Add Staffs</a
            >
          </div>
        </div>
        <div
          id="filter_inputs"
          v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
        >
          <div class="row">
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <div class="sel-cal Calendar-icon">
                  <span><i class="ti ti-calendar-month"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="SaffSel" id="staffsel" placeholder="Staff ID" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="BrianSelect" id="brianselect" placeholder="Staff" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xl">
              <div class="mb-3">
                <vue-select :options="InSelct" id="inselct" placeholder="Status" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="provide-table manage-table">
            <div class="table-responsive">
              <table class="table datatable">
                <thead class="thead-light">
                  <tr>
                    <th>Staff ID</th>
                    <th>Staffs Name</th>
                    <th>Created On</th>
                    <th>No of Services</th>
                    <th>Total Bookings</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>ST0263</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/profiles/avatar-02.jpg"
                            class="rounded-circle"
                            alt="user"
                          />
                        </router-link>
                        <div>
                          <h6 class="fs-14 fw-medium">
                            <router-link to="/provider/staff-details">Anthony Lewis</router-link>
                          </h6>
                          <span class="fs-12">anthony@example.com</span>
                        </div>
                      </div>
                    </td>
                    <td>14/01/2024</td>
                    <td>2</td>
                    <td>0</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Active
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-staff"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#del-staff"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>ST5246</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/profiles/avatar-35.jpg"
                            class="rounded-circle"
                            alt="user"
                          />
                        </router-link>
                        <div>
                          <h6 class="fs-14 fw-medium">
                            <router-link to="/provider/staff-details"
                              >Brian Villalobos</router-link
                            >
                          </h6>
                          <span class="fs-12">brian@example.com</span>
                        </div>
                      </div>
                    </td>
                    <td>21/01/2024</td>
                    <td>3</td>
                    <td>4</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Active
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-staff"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#del-staff"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>ST7645</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/profiles/avatar-36.jpg"
                            class="rounded-circle"
                            alt="user"
                          />
                        </router-link>
                        <div>
                          <h6 class="fs-14 fw-medium">
                            <router-link to="/provider/staff-details">Harvey Smith</router-link>
                          </h6>
                          <span class="fs-12">harvey@example.com</span>
                        </div>
                      </div>
                    </td>
                    <td>20/02/2024</td>
                    <td>2</td>
                    <td>6</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Active
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-staff"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#del-staff"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>ST1269</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/profiles/avatar-11.jpg"
                            class="rounded-circle"
                            alt="user"
                          />
                        </router-link>
                        <div>
                          <h6 class="fs-14 fw-medium">
                            <router-link to="/provider/staff-details">Stephan Peralt</router-link>
                          </h6>
                          <span class="fs-12">peral@example.com</span>
                        </div>
                      </div>
                    </td>
                    <td>15/03/2024</td>
                    <td>6</td>
                    <td>10</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="badge badge-success-100 d-flex align-items-center">
                          <i class="ti ti-point-filled"></i>
                          Active
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-staff"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#del-staff"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>ST7436</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/profiles/avatar-15.jpg"
                            class="rounded-circle"
                            alt="user"
                          />
                        </router-link>
                        <div>
                          <h6 class="fs-14 fw-medium">
                            <router-link to="/provider/staff-details">Doglas Martini</router-link>
                          </h6>
                          <span class="fs-12">martniwr@example.com</span>
                        </div>
                      </div>
                    </td>
                    <td>12/04/2024</td>
                    <td>2</td>
                    <td>15</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span
                          class="badge badge-danger-transparent d-flex align-items-center"
                        >
                          <i class="ti ti-point-filled"></i>
                          Inactive
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-staff"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#del-staff"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>ST3695</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/profiles/avatar-20.jpg"
                            class="rounded-circle"
                            alt="user"
                          />
                        </router-link>
                        <div>
                          <h6 class="fs-14 fw-medium">
                            <router-link to="/provider/staff-details">Linda Ray</router-link>
                          </h6>
                          <span class="fs-12">ray456@example.com</span>
                        </div>
                      </div>
                    </td>
                    <td>20/05/2024</td>
                    <td>1</td>
                    <td>12</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span
                          class="badge badge-danger-transparent d-flex align-items-center"
                        >
                          <i class="ti ti-point-filled"></i>
                          Inactive
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-staff"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#del-staff"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>ST5348</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <router-link to="/provider/staff-details" class="avatar avatar-lg me-2">
                          <img
                            src="@/assets/img/user/user-01.jpg"
                            class="rounded-circle"
                            alt="user"
                          />
                        </router-link>
                        <div>
                          <h6 class="fs-14 fw-medium">
                            <router-link to="/provider/staff-details">Elliot Murray</router-link>
                          </h6>
                          <span class="fs-12">murray@example.com</span>
                        </div>
                      </div>
                    </td>
                    <td>06/07/2024</td>
                    <td>1</td>
                    <td>4</td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <span
                          class="badge badge-danger-transparent d-flex align-items-center"
                        >
                          <i class="ti ti-point-filled"></i>
                          Inactive
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-staff"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#del-staff"
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="table-paginate d-flex justify-content-between align-items-center flex-wrap row-gap-3"
          >
            <div class="value d-flex align-items-center">
              <span>Show</span>
              <select>
                <option>7</option>
              </select>
              <span>entries</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <span class="me-2 text-gray-9">1 - 07 of 10</span>
              <nav aria-label="Page navigation">
                <ul class="paginations d-flex justify-content-center align-items-center">
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 active d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >1</a
                    >
                  </li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >2</a
                    >
                  </li>
                  <li class="page-item">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >3</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <staff-modal></staff-modal>
  </div>
</template>
